{
  "#SALES_STATISTICS": {
    "TITLE": "Umsatzstatistik",
    "MODULE_TITLE": "Umsatzstatistik",
    "DASHBOARD": "Dashboard",
    "TABLE": "Tabelle",
    "MENU": {
      "DASHBOARD": "Dashboard",
      "TABLE": "Tabelle"
    },
    "FILTER": {
      "TITLE": "Filter",
      "MATCH_LABEL": "Auswahl aus Zeitraum",
      "MATCH": {
        "OR": "In einem der Zeiträume",
        "CURRENT": "Nur im aktuellen Zeitraum",
        "PREVIOUS": "Nur im Vergleichszeitraum"
      },
      "EXTRA_TITLE": "Weitere Filter",
      "SEARCH": "Suchen...",
      "NO_RESULTS": "Keine Treffer",
      "NO_SELECTED": "Keine Auswahl",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen",
      "RESET": "Zurücksetzen",
      "RESET_NAMED": "Filter {{label}} zurücksetzen",
      "LOAD_ERROR": "Fehler",
      "EMPTY": "Leer",
      "RELOAD": "Filter neu laden",
      "LOADING": "Daten werden geladen...",
      "TAB_ALL": "Alle",
      "TAB_SELECTED": "Ausgewählt",
      "NO_NAME": "(Keine Bezeichnung)",
      "APPLY": "Übernehmen",
      "CANCEL": "Abbrechen",
      "BACK": "Zurück",
      "CLEAR_SELECTION": "Auswahl löschen",
      "LOAD_MORE": "Mehr laden...",
      "SALES_ORGS": "Verkaufsorganisationen",
      "PRODUCT_GROUPS": "Produktgruppen",
      "MAIN_GROUPS": "Hauptgruppen",
      "WAREHOUSES": "Lager",
      "DISTRIBUTION_CHANNELS": "Vertriebswege",
      "SUB_GROUPS": "Untergruppen",
      "SUB_SUB_GROUPS": "Unter Untergruppen",
      "PRODUCTS": "Artikel",
      "CUSTOMER_GROUPS": "Kundengruppen",
      "CUSTOMERS": "Kunden",
      "SALES_REPRESENTATIVES": "Vertreter",
      "OLD_STATISTIC_TYPES": "Statistikarten",
      "CONDITION_GROUPS": "Konditionsgruppen",
      "VEHICLE_GROUPS": "Fahrzeuggruppen",
      "VEHICLES": "Fahrzeuge",
      "GROUP": {
        "CROSS": "Allgemein",
        "PRODUCT": "Artikelebene",
        "BELEG": "Belegebene"
      },
      "SORT": {
        "GROUPED": "Gruppiert",
        "UNGROUPED": "Liste"
      },
      "EDIT": {
        "START": "Bearbeiten",
        "DONE": "Fertig",
        "DRAG": "Reihenfolge ändern"
      }
    },
    "DOCUMENT_TYPE": {
      "TITLE": "Belegart",
      "SELECT": "Belegart",
      "PLACEHOLDER": "Belegart"
    },
    "STATISTIC_TYPE": {
      "TITLE": "Statistikart",
      "PLACEHOLDER": "Statistikart",
      "TOTAL": "Gesamt",
      "INTERNAL": "Intern",
      "TOTAL_WITH_INTERNAL": "Gesamt + Intern"
    },
    "ACTIONS": {
      "TITLE": "Aktionen",
      "LOAD_TEMPLATE": "Vorlage laden",
      "SAVE_TEMPLATE": "Vorlage speichern"
    },
    "TEMPLATES": {
      "TITLE": "Vorlagen",
      "PLACEHOLDER": "Vorlage auswählen",
      "NONE": "Keine Vorlage",
      "SAVE": "Speichern",
      "NEW": "Neue Vorlage",
      "EDIT": "Bearbeiten",
      "EDIT_DONE": "Bearbeitung beenden",
      "RENAME": "Umbenennen",
      "DELETE": "Löschen",
      "UNSAVED": "Nicht gespeichert",
      "LAST_SAVED": "Zuletzt gespeichert"
    },
    "CHART": {
      "CHANGE": "Veränderung",
      "SINGLE_SALES_ORG": "Verkaufsorganisation",
      "SALES_ORGS": "Verkaufsorganisationen",
      "SALES_ORGS_SUBTITLE": "Umsätze pro Verkaufsorganisation",
      "SALES_ORGS_SUBTITLE_DB": "DB pro Verkaufsorganisation",
      "SALES_ORGS_SUBTITLE_DB_PERCENT": "DB% pro Verkaufsorganisation",
      "SALES_ORGS_SUBTITLE_INVENTORY": "Lagerwert pro Verkaufsorganisation",
      "PRODUCT_GROUPS": "Produktgruppen",
      "MAIN_GROUPS": "Hauptgruppen",
      "SUB_GROUPS": "Untergruppen",
      "SUB_SUB_GROUPS": "Unter-Untergruppen",
      "PRODUCTS": "Artikel",
      "CUSTOMER_GROUPS": "Kundengruppen",
      "CUSTOMERS": "Kunden",
      "SALES_REPRESENTATIVES": "Vertreter",
      "DRILL_UP": "Zurück",
      "VIEW_PREV": "Eine Ebene zurück",
      "VIEW_NEXT": "Eine Ebene tiefer",
      "SALES_TREND": "Umsatz Verlauf",
      "DB_TREND": "DB Verlauf",
      "DB_PERCENT_TREND": "DB% Verlauf",
      "INVENTORY_TREND": "Lagerwert Verlauf",
      "SALES_FOR": "Umsätze für",
      "DB_FOR": "DB für",
      "DB_PERCENT_FOR": "DB% für",
      "INVENTORY_FOR": "Lagerwert für",
      "TOP_15_SALES_FOR": "Top 15 Umsätze für",
      "TOP_15_INVENTORY_FOR": "Top 15 Lagerwert für",
      "TOP_15_DB_FOR": "Top 15 DB für",
      "TOP_15_DB_PERCENT_FOR": "Top 15 DB% für",
      "WAREHOUSE_INVENTORY": "Lager",
      "WAREHOUSE_INVENTORY_FOR": "Lagerwert pro Lager für",
      "ALL_SALES_ORGS": "alle Verkaufsorganisationen",
      "ALL_WAREHOUSES": "alle Lager",
      "FOR": "für",
      "PRODUCT_GROUP": "Produktgruppe",
      "ALL_PRODUCT_GROUPS": "alle Produktgruppen",
      "AND": "und",
      "AMOUNT_IN_EUR": "Betrag in €",
      "PERCENT": "Anteil in %",
      "SHOW_AS_BAR": "Als Balkendiagramm anzeigen",
      "SHOW_AS_DONUT": "Als Ringdiagramm anzeigen"
    },
    "SERIES": {
      "NET": "Netto",
      "WES": "WES",
      "DB": "DB",
      "SALES": "Umsatz",
      "DB_PERCENT": "DB%",
      "SALES_POSITIVE": "Umsatz-Zuwachs",
      "SALES_NEGATIVE": "Umsatz-Rückgang",
      "DB_POSITIVE": "DB-Zuwachs",
      "DB_NEGATIVE": "DB-Rückgang",
      "DB_PERCENT_POSITIVE": "DB%-Zuwachs",
      "DB_PERCENT_NEGATIVE": "DB%-Rückgang",
      "INVENTORY_POSITIVE": "Lagerwert-Zuwachs",
      "INVENTORY_NEGATIVE": "Lagerwert-Rückgang",
      "REFERENCE": "Vergleich"
    },
    "TOTAL": {
      "SALES": "Umsatz",
      "CONTRIBUTION_MARGIN": "Deckungsbeitrag (DB)",
      "DB_PERCENT": "Deckungsbeitrag Prozent",
      "INVENTORY_VALUE": "Lagerwert",
      "COMPARISON": "Vergleich",
      "ACHIEVED": "erreicht"
    },
    "ERROR": {
      "LOAD_FAILED": "Daten konnten nicht geladen werden"
    },
    "COLUMNS": {
      "SALES_ORG": "Verkaufsorganisation",
      "PRODUCT_GROUP": "Produktgruppe",
      "MAIN_GROUP": "Hauptgruppe",
      "SUB_GROUP": "Untergruppe",
      "PRODUCT": "Artikel",
      "CUSTOMER": "Kunde",
      "DATE": "Datum",
      "NET": "Netto",
      "NET_COMPARISON": "Netto Veränderung",
      "NET_COMPARISON_VALUE": "Netto Vergleich",
      "NET_CHANGE_VALUE": "Netto Veränderung €",
      "NET_DEVELOPMENT": "Netto Entwicklung",
      "WES": "WES",
      "WES_COMPARISON": "WES Veränderung",
      "WES_COMPARISON_VALUE": "WES Vergleich",
      "WES_CHANGE_VALUE": "WES Veränderung €",
      "DB": "DB",
      "DB_COMPARISON": "DB Veränderung",
      "DB_COMPARISON_VALUE": "DB Vergleich",
      "DB_CHANGE_VALUE": "DB Veränderung €",
      "DB_DEVELOPMENT": "DB Entwicklung",
      "DB_PERCENT": "DB%",
      "INVENTORY_VALUE": "Lagerwert",
      "INVENTORY_VALUE_COMPARISON": "Lagerwert Veränderung",
      "INVENTORY_VALUE_COMPARISON_VALUE": "Lagerwert Vergleich",
      "INVENTORY_VALUE_CHANGE_VALUE": "Lagerwert Veränderung €",
      "INVENTORY_VALUE_DEVELOPMENT": "Lagerwert Entwicklung",
      "ACTIONS": "Aktionen"
    },
    "NO_DATA": "Keine Daten verfügbar"
  }
}
